import React, { useState, useEffect, useRef } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { FadeInAndShrink } from "./AnimationLibrary";
import {Button} from "./Button";

const Alert = props => {
	// eslint-disable-next-line
	const [value, setValue] = useState("");
	const [copySuccess, setCopySuccess] = useState(false);
	const [expanded, setExpanded] = useState(false);
	const [alertVisible, setAlertVisible] = useState(true);
	const wrapper = useRef(null);

	const handleExpand = () => {
		setExpanded(!expanded);
		if (copySuccess === true) {
			setCopySuccess(false);
		}
	};

	const onCopy = () => {
		setValue({ copied: true });
		setCopySuccess(true);
	};

	// Only display "View More" and "View Less" when the messageDetail prop is provided
	const showMessageDetail = (collapseText, expandText) => {
		if (!props.messageDetail)	return "";
		return (
			<span className="disclosure-toggle" onClick={handleExpand}>
				{expanded ? (
					<>
						{props.collapseText ? collapseText : "View less"}<span className="up">&#xFFEA;</span>
					</>
				) : (
					<>
						{props.expandText ? expandText : "Error details"} <span className="down">&#xFFEC;</span>
					</>
				)}
			</span>
		);
	};

	const showMessageDetailTextArea = () => {
		if (!props.messageDetail || !expanded) return "";

		return (
			<form>
				<textarea
					className={`alert-message__message-detail  ${expanded ? "expanded" : ""}`}
					value={props.messageDetail}
					spellCheck="false"
					onChange={e => e.target.value}
				/>
				<CopyToClipboard onCopy={onCopy} text={props.messageDetail}>
					<img className="alert-message__message-detail__copy" src="../images/copy.svg" alt="Copy to clipboard"/>
				</CopyToClipboard>
				{copySuccess ? <span>Copied to clipboard</span> : ""}
			</form>
		);
	};

	const showActionButtons = () => {
		return (
			<>
				<div className="btn-row">
					{props.buttonTextPrimary && <Button onClick={props.onClickPrimary} text={props.buttonTextPrimary} buttonType="primary"/>}
					{props.buttonTextSecondary && <Button onClick={props.onClickSecondary} text={props.buttonTextSecondary} buttonType="secondary"/>}
				</div>
			</>
		)
	}

	const showTextLink = () => {
		return (
			<>
				{props.textLinkLabel && props.textLinkOnClick && <p className="alert-text-link" onClick={props.textLinkOnClick} >{props.textLinkLabel}</p>}
			</>
		)
	}

	const useDismissOnOutsideClick = ref => {
		const handleClickOutside = (event) => {
			if (alertVisible && ref.current && !ref.current.contains(event.target)) {
				setAlertVisible(false);
				props.close();
			}
		}

		useEffect(() => {
			document.addEventListener("mousedown", handleClickOutside);
			return () => {
				document.removeEventListener("mousedown", handleClickOutside);
			};
		});
	};
	
	useDismissOnOutsideClick(wrapper);

	return (
		<div className={`modal ${!alertVisible ? "not-visible" : ""}`}>
			<FadeInAndShrink delay="500">
				<div ref={props.dismissable !== false ? wrapper : null} className={`alert ${props.type ? props.type : "error"}`}>
					<div className="alert-message">
						<h2 className="alert-message__title">
							{props.title ? props.title : "Oops! Something went wrong"}
						</h2>
						<p className="alert-message__message">{props.message}</p>
						{showActionButtons()}
						{showMessageDetail(props.collapseText, props.expandText)}
						{showMessageDetailTextArea()}
						{showTextLink()}
					</div>
					{props.dismissable !== false && 
						<button type="button" className="close" aria-label="Close" onClick={props.close}>
						&times;
						</button>
					}
				</div>
			</FadeInAndShrink>
		</div>
	);
};

export default Alert;
